import routes from './_routes'; // generated by go

// Function to handle adding a new file token to an input and creating preview
const handleNewFileToken = function (data, dataFor, fileInput = null) {
  const fileTokensContainer = document.getElementById(dataFor);
  const newFile = {
    file: data.file || data.name,
    ...data,
  };

  // Update the hidden input value with the new file token
  const oldValue = fileTokensContainer.value;
  let newValue = "";
  if (oldValue != "" && (fileInput?.hasAttribute("multiple") ?? true)) {
    try {
      const tokens = JSON.parse(oldValue);
      tokens.push(newFile);
      newValue = JSON.stringify(tokens);
    } catch (e) {
      newValue = JSON.stringify([newFile]);
    }
  } else {
    newValue = JSON.stringify([newFile]);
  }
  fileTokensContainer.value = newValue;

  // Create preview if container exists
  const previewContainer = document.getElementById("preview-" + dataFor);
  if (previewContainer) {
    const preview = showFilePreview(newFile, dataFor);
    preview.classList.add("file-preview");
    previewContainer.appendChild(preview);
  }

  // If we have a file list (from regular upload), update it
  if (fileInput) {
    const fileList =
      fileInput.parentElement.parentElement.getElementsByClassName("files")[0];
    if (fileList) {
      const fileInfoContainer = document.createElement("div");
      fileInfoContainer.classList.add("file");
      const fileInfo = document.createElement("div");
      fileInfo.classList.add("file-info");
      const fileName = document.createElement("div");
      fileName.classList.add("file-name");
      fileName.innerHTML = `<div class="icon small icon-document-page"></div><div>${
        newFile.file || newFile.filename
      }</div>`;
      const deleteButton = document.createElement("button");
      deleteButton.classList.add("button", "border");
      deleteButton.innerHTML = '<span class="icon small icon-trash"></span>';
      deleteButton.setAttribute("data-token", data.token);
      deleteButton.setAttribute("data-for", dataFor);
      bindDeleteButton(deleteButton);

      fileInfo.appendChild(fileName);
      fileInfo.appendChild(deleteButton);
      fileInfoContainer.appendChild(fileInfo);

      if (!fileInput.hasAttribute("multiple")) {
        deleteOldFiles(fileList);
        fileList.innerHTML = "";
      }
      fileList.appendChild(fileInfoContainer);
    }
  }

  // Dispatch change event
  const event = new Event("change");
  fileTokensContainer.dispatchEvent(event);
};

// Make it available globally for external use
window.handleNewFileToken = handleNewFileToken;

const bindDeleteButton = function (deleteButton) {
  deleteButton.addEventListener("click", function (e) {
    e.preventDefault();
    const token = deleteButton.getAttribute("data-token");
    const fileTokensContainer = document.getElementById(
      deleteButton.getAttribute("data-for")
    );
    const fileTokens = JSON.parse(fileTokensContainer.value);

    fetch(`${routes.filesBaseURL}/${token}`, {
      method: "DELETE",
    })
      .then(function () {
        const newFileTokens =
          fileTokens.filter(function (file) {
            return file.token !== token;
          }) || "[]";
        fileTokensContainer.value = JSON.stringify(newFileTokens);
        // div file -> div file-info -> delete button and other things
        deleteButton.parentElement.parentElement.remove();
        const event = new Event("change");
        fileTokensContainer.dispatchEvent(event);
      })
      .catch(function (error) {
        console.error("Error:", error);
      });
  });
  deleteButton.classList.add("initialized");
};

const deleteOldFiles = function (fileList) {
  const deleteButtons = fileList.querySelectorAll("button");
  deleteButtons.forEach(function (button) {
    const token = button.getAttribute("data-token");

    fetch(`${routes.filesBaseURL}/${token}`, {
      method: "DELETE",
    });
    // Don't really need to do anything with the response
    // Perhaps log something to our logging service if it fails
    // but the user doesn't really care if the old file
    // was marked as deleted or not as it does not affect
    // the user experience, as long as the new file is uploaded.

    // Clear orphan files every N days?
  });
};

const showFilePreview = (data, dataFor) => {
  const fileUrl = `${routes.fileBaseURL}${data.token}`;

  const previewContainer = document.createElement("div");
  previewContainer.innerHTML = "";
  previewContainer.classList.add("file-preview");

  if (data["content_type"].indexOf("image") === 0) {
    const img = document.createElement("img");
    img.src = fileUrl;
    img.alt = "Image Preview";
    img.style.maxWidth = "200px";
    previewContainer.appendChild(img);
  } else if (data["content_type"] === "application/pdf") {
    previewContainer.innerHTML = `<i class="icon-file-paper">PDF File</i>`;
  } else if (data["content_type"] === "text/plain") {
    previewContainer.innerHTML = `<i class="icon-file-paper">Text File</i>`;
  } else if (
    data["content_type"] ===
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
  ) {
    previewContainer.innerHTML = `<i class="icon-file-paper">Word Document</i>`;
  } else {
    previewContainer.innerHTML = `<i class="icon-file-paper">Unknown File Type</i>`;
  }

  const fileInfoContainer = document.createElement("div");
  fileInfoContainer.classList.add("file-info");
  fileInfoContainer.classList.add("flex-center");
  fileInfoContainer.innerHTML = `<div class="file-name">${data.file}</div> <button class="button border"><span class="icon small icon-trash"></span></button>`;
  const deleteButton = fileInfoContainer.querySelector("button");
  deleteButton.setAttribute("data-token", data.token);
  deleteButton.setAttribute("data-for", dataFor);

  bindDeleteButton(deleteButton);

  previewContainer.appendChild(fileInfoContainer);
  return previewContainer;
};

const initiateFileUploads = function () {
  const fileInputs = document.querySelectorAll(".file-upload");
  if (fileInputs.length === 0) return;

  const excluded = document.getElementById("excluded");
  if (!excluded) {
    console.warn(
      "This page does not contain the excluded form, please include it to ensure files are not duplicated."
    );
  }

  const deleteButtons = document.querySelectorAll(".file-info button");
  deleteButtons.forEach(function (button) {
    if (!button.classList.contains("initialized")) {
      bindDeleteButton(button);
    }
  });

  fileInputs.forEach(function (fileInput) {
    if (fileInput.classList.contains("initialized")) {
      return;
    }
    const dropzone = fileInput.parentElement;

    dropzone.addEventListener("dragover", function (e) {
      e.preventDefault();
      dropzone.classList.add("dragover");
    });

    dropzone.addEventListener("dragleave", function () {
      dropzone.classList.remove("dragover");
    });

    dropzone.addEventListener("drop", function (e) {
      e.preventDefault();
      dropzone.classList.remove("dragover");

      // Check if droped item is of accepted type
      const acceptedTypes = fileInput.accept
        .split(",")
        .map((type) => type.trim());
      const droppedFiles = Array.from(e.dataTransfer.files);

      const validFiles = droppedFiles.filter((file) => {
        return acceptedTypes.some((type) => {
          if (type.startsWith(".")) {
            return file.name.endsWith(type);
          } else {
            return (
              file.type === type ||
              (type.endsWith("/*") && file.type.startsWith(type.split("/")[0]))
            );
          }
        });
      });

      if (validFiles.length === 0) {
        console.warn("Invalid file type.");
        var errEl = document.createElement("span");
        errEl.innerHTML = "Ungültiger Dateityp";
        errEl.classList.add("error");
        errEl.classList.add("mt");
        errEl.id = "file-type-error";
        dropzone.parentElement.appendChild(errEl);
        return;
      }

      const erEll = document.querySelector("#file-type-error");
      if (erEll) {
        erEll.remove();
      }

      const dataTransfer = new DataTransfer();
      validFiles.forEach((file) => dataTransfer.items.add(file));
      fileInput.files = dataTransfer.files;

      const event = new Event("change");
      fileInput.dispatchEvent(event);
    });

    fileInput.addEventListener("change", function () {
      const files = fileInput.files;
      const dataFor = fileInput.getAttribute("data-for");

      const fileTokensContainer = document.getElementById(dataFor);

      const fileInfoContainer = document.createElement("div");
      fileInfoContainer.classList.add("file");

      const acceptedTypes = fileInput.accept.split(",");
      Array.from(files).forEach((file) => {
        if (Array.from(acceptedTypes).includes(file.type)) {
          const formData = new FormData();
          formData.append("file", file);

          const xhr = new XMLHttpRequest();
          xhr.open("POST", routes.filesBaseURL, true);

          const fileInfo = document.createElement("div");
          fileInfo.classList.add("file-info");
          const fileName = document.createElement("div");
          fileName.classList.add("file-name");
          fileName.innerHTML = `<div class="icon small icon-document-page"></div><div>${file.name}</div>`;
          const deleteButton = document.createElement("button");
          deleteButton.classList.add("button");
          deleteButton.classList.add("border");
          deleteButton.innerHTML =
            '<span class="icon small icon-trash"></span>';
          const fileProgress = document.createElement("progress");
          fileProgress.max = "100";
          fileInfoContainer.appendChild(fileInfo);
          fileInfo.appendChild(fileName);
          fileInfo.appendChild(deleteButton);
          fileInfoContainer.appendChild(fileProgress);

          const fileList =
            fileInput.parentElement.parentElement.getElementsByClassName(
              "files"
            )[0];
          if (!fileInput.hasAttribute("multiple")) {
            deleteOldFiles(fileList);
            fileList.innerHTML = "";
          }
          fileList.appendChild(fileInfoContainer);

          const submitButtons = document.querySelectorAll(
            "button[type='submit']"
          );

          xhr.upload.addEventListener("progress", function (e) {
            // Disable submit-buttons to ensure the file will be uploaded
            if (!submitButtons[0].classList.contains("disabled")) {
              submitButtons.forEach((submitbtn) => {
                submitbtn.classList.add("disabled");
                submitbtn.disabled = true;
              });
            }

            const previewContainer = document.getElementById(
              "preview-" + dataFor
            );
            if (previewContainer) {
              const withpreviewLoader = previewContainer.querySelector(
                ".with-preview-loader"
              );
              if (withpreviewLoader) {
                withpreviewLoader.classList.remove("hidden");
              }
            }
            if (e.loaded && e.total) {
              const percentComplete = Math.round((e.loaded / e.total) * 100);
              fileProgress.value = percentComplete;
            }
          });

          xhr.addEventListener("load", function () {
            submitButtons.forEach((submitbtn) => {
              submitbtn.classList.remove("disabled");
              submitbtn.disabled = false;
            });
            const previewContainer = document.getElementById(
              "preview-" + dataFor
            );
            if (xhr.status === 201) {
              const data = JSON.parse(xhr.responseText);
              const newFile = {
                file: file.name,
                ...data,
              };
              fileInfoContainer.remove();
              handleNewFileToken(newFile, dataFor, fileInput);
            } else {
              console.error("Error:", xhr.statusText);
            }
            if (previewContainer) {
              const withpreviewLoader = previewContainer.querySelector(
                ".with-preview-loader"
              );
              if (withpreviewLoader) {
                withpreviewLoader.classList.add("hidden");

                // Move loader to be last child
                withpreviewLoader.parentNode.appendChild(withpreviewLoader);
              }
            }
          });

          xhr.addEventListener("error", function () {
            console.error("Error:", xhr.statusText);
          });

          xhr.send(formData);
        } else {
          console.warn("Invalid file type.");
          var errEl = document.createElement("span");
          errEl.innerHTML = "Ungültiger Dateityp";
          errEl.classList.add("error");
          errEl.classList.add("mt");
          errEl.id = "file-type-error";
          dropzone.parentElement.appendChild(errEl);
        }
      });
    });

    fileInput.classList.add("initialized");
  });
};

window.addEventListener("load", initiateFileUploads);
document.addEventListener("htmx:afterSwap", (evt) => {
  if (evt.detail.elt.getAttribute("hx-swap") !== "none") {
    initiateFileUploads();
  }
});

// Used in funnels where we dynamically add uploads-field (f.ex. ir_meterreadings)
document.addEventListener("alpine:init-fileuploads", () => {
  // Need timeout to let dom elements to be created
  setTimeout(() => {
    initiateFileUploads();
  }, 200);
});
